import { useSelector } from 'react-redux'
import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from './store'
import { useDispatchActions, setStoreState } from './utils'
import { storageUtil } from '@/utils'

const { setLocalStorage, getLocalStorage } = storageUtil

export interface CorpInfo {
  corpId: string
  phone: string
  token: string
  customerId: string
  accountId: string
  [key: string]: any
}

const initialState: CorpInfo = {
  corpId: '',
  customerId: '',
  accountId: '',
  phone: '',
  token: '',
  corpLogo: '',
  corpName: '',
  corpIntroWord: '',
  address: '',
  cloudStoreContactPhone: '',
  cloudStoreNotice: '',
  isTempLogin: false,
}

export const slice = createSlice({
  name: 'corpInfo',
  initialState,
  reducers: {
    setCorpInfo: (state, action: PayloadAction<CorpInfo>) => {
      const payload = action.payload
      state.isTempLogin === Boolean(!payload.accountId)
      setStoreState(state, payload)
      setLocalStorage('corpInfo', payload)

      if (payload.tempToken) {
        sessionStorage.setItem('tempToken', payload.tempToken)
      } else {
        setLocalStorage('token', payload.token)
      }
    },
    setToken: (state, action: PayloadAction<string>) => {
      if (!action.payload) return;
      const token = action.payload
      state.token = token
      setLocalStorage('token', token)
    }
  },
})

export const { setCorpInfo: corpInfoActionCreator } = slice.actions
export const reducer = slice.reducer

export default function useCorpInfoStore() {
  const state = useSelector((state: RootState) => state.corpInfo)
  const storageState = getLocalStorage('corpInfo', true) || {}
  const token = getLocalStorage('token')
  const actionPool = useDispatchActions(slice.actions)
  const totalState = { ...state, ...storageState, token }

  return {
    corpInfo: totalState,
    ...actionPool,
  }
}
